import { render, staticRenderFns } from "./safety-device.vue?vue&type=template&id=740089d4&scoped=true&"
import script from "./safety-device.vue?vue&type=script&lang=js&"
export * from "./safety-device.vue?vue&type=script&lang=js&"
import style0 from "./safety-device.vue?vue&type=style&index=0&id=740089d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740089d4",
  null
  
)

export default component.exports